import React, { useContext, useMemo } from "react";
import { string, oneOf, array, bool, func } from "prop-types";
import { SelectDropdown } from "./";
import { useTextDomainContext } from "@/app/providers";
import currencies from "@/utils/static/currencies.json";

export const CurrencyDropdown = (props: any) => {
  const { TextDomainContext } = useTextDomainContext();
  const { gettext } = useContext(TextDomainContext);

  //#region useMemo
  const options = useMemo(() => {
    return currencies;
  }, []);

  const componentLabel = useMemo(() => {
    return props.componentLabel || gettext("Currency");
  }, [gettext, props.componentLabel]);
  //#endregion useMemo

  return (
    <>
      <SelectDropdown
        options={
          options as unknown as import("@/types/Dropdown.types").DropdownOption[]
        }
        componentLabel={componentLabel}
        showAll={props.showAll}
        defaultValue={props.defaultValue}
        onChange={props.onChange}
        visualStyle="autoComplete"
      />
    </>
  );
};

CurrencyDropdown.propTypes = {
  componentLabel: string,
  defaultValue: oneOf([string, array]),
  showAll: bool,
  onChange: func,
};
